<template>
	<layout-main>
		<template #toolbar>
			<layout-tool-bar />
		</template>

		<v-container class="fill-wh">
			<router-view v-if="$route.name !== 'PM Home'" />
			<nav-tiles v-else :tiles="tiles" @click:tile="navigate" />
		</v-container>
	</layout-main>
</template>

<script>
import { mapGetters } from "vuex";

import strings from "@/utils/strings";

export default {
	data: () => ({
		strings: strings.project,
	}),

	computed: {
		...mapGetters({
			tiles: "menu/getPMTiles",
		}),
	},

	methods: {
		navigate(to) {
			return this.$router.push(to);
		},
	},
};
</script>
